import * as __model from '../model';

export class magazineInfo {
magazineName?: string;
magazineId?: number;
magazineThumbnailUrl?: string;
}